import React from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../../../../../hooks/auth'

import './MenuLink.css'

type Props = {
    className?: string
}

export const MenuLoginLink: React.FC<Props> = ({ className }) => {
    const { user } = useAuth()

    return (
        <Link to="auth" className={'menu_link ' + className}>
            {user ? 'Вернуться в сервис' : 'Вход в сервис'}
        </Link>
    )
}
